import SignUpForm from "../../components/sign-up-form/sign-up-form.component";
import "./sign-up.styles.scss";

export default function SignUp() {
  return (
    <div className="sign-up-container">
      <SignUpForm />
    </div>
  );
}
